import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "../utils";
import { useAuth0 } from "@auth0/auth0-react";
import request from "@/lib/api/handler";
import { ConversationMessage } from "./user-chat";

interface ConversationParticipantBase {
  name?: string;
  avatarLink?: string;
}

export type ConversationParticipant =
  | (ConversationParticipantBase & { userId: string; companyId?: never })
  | (ConversationParticipantBase & { companyId: string; userId?: never });

export interface ConversationSummary {
  id: string;
  title?: string;
  participants: ConversationParticipant[];
  jobOpeningId?: string;
  lastMessage?: ConversationMessage;
  lastSeenAt?: string;
  lastSeenMessageId?: string;
}

export const useConversationsQuery = () => {
  const { getAccessTokenSilently } = useAuth0();

  const { isLoading, data, error } = useQuery({
    queryKey: QueryKeys.chatConversations,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    enabled: true,
    async queryFn() {
      const token = await getAccessTokenSilently();
      return request<ConversationSummary[]>({
        method: "GET",
        path: "/api/chat/conversations",
        token,
      });
    },
  });

  return {
    chatConversationsLoading: isLoading,
    chatConversations: data ?? null,
    chatConversationsError: error ?? null,
  };
};
